export default __webpack_public_path__ + "static/media/debit-card.ca3efa05.png";